module.exports = __webpack_public_path__ + "img/162.da170a18.jpg";